import 'style/global.scss'

export let token = {}
export let componentsToken = {}

export const extendToken = (newToken) => {
  token = { ...token, ...newToken }
}

export const extendComponentsToken = (newComponentsToken) => {
  componentsToken = { ...componentsToken, ...newComponentsToken }
}
